import { Box, IconProps } from '@bitrise/bitkit';

export type ColorBarProps = { color: IconProps['color']; width?: string; height?: string };
const ColorBar = ({ color, width = '8', height = 'auto' }: ColorBarProps): JSX.Element => (
  <Box width={width} height={height} backgroundColor={color} flexShrink={0} />
);

export default ColorBar;
